import vue from "vue";

export const fetchCategoryItemsList = async (data) => {
  const res = await vue.axios.post(
    `/catalog/api/catalog/read/catalog/item/by?page=${data[1]}`,
    data[0]
  );
  return res.data.response;
};
